import axiosInstance from '../../api/axiosInstance';

export const generarGuiaEnvia = async (
  cotizacionData: any,
  formData: any,
  orderDetail: any,
  selectedTipoServicio: string
) => {
  const token = localStorage.getItem("accessToken");
  if (!token) {
    throw new Error("Error de autenticación");
  }

  const configData = {
    cod_regional_cta: 3,
    cod_oficina_cta: 1, 
    codigo_cuenta: 5011,
    codigo_cuenta_recaudo: 5012,
    num_unidades: 1,
    codFormaPago: 4,
    ciudad_destin_ej: ''
  };

  // Calcular peso volumétrico y redondearlo a entero
  const pesoVolumetrico = Math.ceil((formData.largo * formData.ancho * formData.altura) / 4504);
  const valorProducto = formData.metodoPago === 'cod' ? Math.round(parseFloat(orderDetail?.total || "0")) : 0;
  const valorDeclarado = parseInt(formData.valorDeclarado?.toString() || "0");
  const codigo_cuenta = formData.metodoPago === "cod" ? configData.codigo_cuenta_recaudo : configData.codigo_cuenta;

  const guiaData = {
    transportadora: 'Envía',
    ciudad_origen: "05001",
    ciudad_destino: configData.ciudad_destin_ej || orderDetail?.shippingAddress?.city,
    cod_formapago: 4,
    cod_servicio: parseInt(selectedTipoServicio),
    num_unidades: configData.num_unidades,
    mpesoreal_k: Math.ceil(formData.peso),
    mpesovolumen_k: pesoVolumetrico,
    valor_declarado: valorDeclarado,
    mca_nosabado: 0,
    mca_docinternacional: 0,
    cod_regional_cta: configData.cod_regional_cta,
    cod_oficina_cta: configData.cod_oficina_cta,
    cod_cuenta: codigo_cuenta,
    con_cartaporte: "0",
    num_ordens: orderDetail?.id?.toString() || "",
    info_origen: {
      nom_remitente: formData.origenNombre,
      dir_remitente: formData.origenDireccion,
      tel_remitente: formData.origenCelular,
      ced_remitente: formData.origenNit || ""
    },
    info_destino: {
      nom_destinatario: formData.destinoNombre,
      dir_destinatario: formData.destinoDireccion + ', ' + formData.destinoDireccion_2,
      tel_destinatario: formData.destinoCelular,
      ced_destinatario: formData.destinoNit || ""
    },
    info_contenido: {
      dice_contener: formData.contenido,
      texto_guia: "",
      accion_notaguia: orderDetail?.extraDetails?.customer_note || "",
      num_documentos: orderDetail?.id?.toString() || "",
      centrocosto: "",
      valorproducto: valorProducto,
    }
  };

  console.log('🚀 Generando guía con Envía:', JSON.stringify(guiaData, null, 2));

  const response = await axiosInstance.post("/guias/generar", guiaData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  return response.data;
};
